export const DATE_UPDATED = 'WEEK/DATE_UPDATED';
export const REGISTERED_LISTENER = 'WEEK/REGISTERED_LISTENER';
export const SET_PUBLIC_HOLIDAY = 'WEEK/SET_PUBLIC_HOLIDAY';
export const SET_DAY_OFF = 'WEEK/SET_DAY_OFF';
export const SET_WEEK = 'WEEK/SET_WEEK';
export const LOAD_DATE = 'WEEK/LOAD_DATE';